import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import './links.css';
import { Button,Header,Container,Icon,Grid,Card,Image,Popup,Message } from 'semantic-ui-react';

// qr codes
import jalgaonqr from './assets/jalgaonqr.png';
import puneqr from './assets/puneqr.png';
import mumbaiqr from './assets/mumbaiqr.png';
import nashikqr from './assets/nashikqr.png';
import nagarqr from './assets/nagarqr.png';

class Links extends React.Component{

    copyLink = (e) =>{
        let tmpInp = document.querySelector("#copystub");
        let link = e.target.dataset.link
        tmpInp.value=link;
        tmpInp.select();
        document.execCommand('copy');
        window.location.href = `#${e.target.dataset.id}`;
    }

    render(){
        return(
            <Container>
                <Grid columns={4} centered={true} stackable>
                    <Grid.Row textAlign="center">
                        <Grid.Column className="whoarewe">
                            {/* <Header as="h2">Who are we ?</Header> */}
                            <a href="/team">
                            <Message
                                color="teal"
                                floating
                                icon='user secret'
                                header='Who are we ?'
                                content='good question ! just click here'
                            /></a>
                        </Grid.Column>
                    </Grid.Row>    
                <Grid.Row textAlign="center">
                    <Grid.Column className="groupsColumn">
                        <Card id="card1">
                            <Image src={jalgaonqr} wrapped ui={false}/>
                            <Card.Content textAlign="center">
                                <Card.Header>
                                    <Header as="h2"> Jalgaon </Header>
                                </Card.Header>
                            </Card.Content>
                            <Card.Content extra>
                                <a href="https://t.me/autocowinjalgaon">
                                    <Button className="btn join" color="blue" size="large">
                                        <Icon name="telegram plane"/>  Join
                                    </Button>
                                </a>
                                <Popup
                                    trigger={
                                        <Button data-id="card1" className="btn copy" color="blue" size="large" data-link="https://t.me/autocowinjalgaon"
                                            onClick={this.copyLink}>
                                            <Icon name="copy"/>  Copy group link
                                        </Button>
                                    }
                                    content={<div className="copied"><Icon name="check"/> Copied !</div>}
                                    on='click'
                                    position='top center'
                                />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column className="groupsColumn">
                        <Card id="card2">
                            <Image src={puneqr} wrapped ui={false}/>
                            <Card.Content textAlign="center">
                                <Card.Header>
                                    <Header as="h2"> Pune </Header>
                                </Card.Header>
                            </Card.Content>
                            <Card.Content extra>
                                <a href="https://t.me/autocowinpune">
                                    <Button className="btn join" color="blue" size="large">
                                        <Icon name="telegram plane"/>  Join
                                    </Button>
                                </a>
                                <Popup
                                    trigger={
                                        <Button data-id="card2" className="btn copy" color="blue" size="large" data-link="https://t.me/autocowinpune"
                                            onClick={this.copyLink}>
                                            <Icon name="copy"/>  Copy group link
                                        </Button>
                                    }
                                    content={<div className="copied"><Icon name="check"/> Copied !</div>}
                                    on='click'
                                    position='top center'
                                />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column className="groupsColumn">
                        <Card id="card3">
                            <Image src={mumbaiqr} wrapped ui={false}/>
                            <Card.Content textAlign="center">
                                <Card.Header>
                                    <Header as="h2"> Mumbai </Header>
                                </Card.Header>
                            </Card.Content>
                            <Card.Content extra>
                                <a href="https://t.me/autocowinmumbai">
                                    <Button className="btn join" color="blue" size="large">
                                        <Icon name="telegram plane"/>  Join
                                    </Button>
                                </a>
                                <Popup
                                    trigger={
                                        <Button data-id="card3" className="btn copy" color="blue" size="large" data-link="https://t.me/autocowinmumbai"
                                            onClick={this.copyLink}>
                                            <Icon name="copy"/>  Copy group link
                                        </Button>
                                    }
                                    content={<div className="copied"><Icon name="check"/> Copied !</div>}
                                    on='click'
                                    position='top center'
                                />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column className="groupsColumn">
                        <Card id="card4">
                            <Image src={nashikqr} wrapped ui={false}/>
                            <Card.Content textAlign="center">
                                <Card.Header>
                                    <Header as="h2"> Nashik </Header>
                                </Card.Header>
                            </Card.Content>
                            <Card.Content extra>
                                <a href="https://t.me/autocowinnashik">
                                    <Button className="btn join" color="blue" size="large">
                                        <Icon name="telegram plane"/>  Join
                                    </Button>
                                </a>
                                <Popup
                                    trigger={
                                        <Button data-id="card4" className="btn copy" color="blue" size="large" data-link="https://t.me/autocowinnashik"
                                            onClick={this.copyLink}>
                                            <Icon name="copy"/>  Copy group link
                                        </Button>
                                    }
                                    content={<div className="copied"><Icon name="check"/> Copied !</div>}
                                    on='click'
                                    position='top center'
                                />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column className="groupsColumn">
                        <Card id="card5">
                            <Image src={nagarqr} wrapped ui={false}/>
                            <Card.Content textAlign="center">
                                <Card.Header>
                                    <Header as="h2"> Ahmednagar </Header>
                                </Card.Header>
                            </Card.Content>
                            <Card.Content extra>
                                <a href="https://t.me/autocowinnagar">
                                    <Button className="btn join" color="blue" size="large">
                                        <Icon name="telegram plane"/>  Join
                                    </Button>
                                </a>
                                <Popup
                                    trigger={
                                        <Button data-id="card5" className="btn copy" color="blue" size="large" data-link="https://t.me/autocowinnagar"
                                            onClick={this.copyLink}>
                                            <Icon name="copy"/>  Copy group link
                                        </Button>
                                    }
                                    content={<div className="copied"><Icon name="check"/> Copied !</div>}
                                    on='click'
                                    position='top center'
                                />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                </Grid.Row>
                </Grid>
                <input type="text" onSelect={(e)=>e.preventDefault()} style={{opacity:"0",position:"absolute",zIndex:"-1",bottom:"-10%"}} id="copystub" value=""></input>
            </Container>
        )
    };
}

export default Links;